import * as types from "../actions/actionTypes";

const initialState = {
  orders: [],
  customers: [],
  order: null,
  totalSale: null,
  totalOrder: null,
  pendingCount: null,
  shippedCount: null,
  packedCount: null,
  deliveredCount: null,
  cancelledCount: null,
  cartBundleId : null,
  customerTotalOrders : {},
  cartBundleIdOrder : [],
  completedcartorder : []
};

const orders = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_ORDERS_RESPONSE:
      return { ...state, orders: action.payload };
    case types.GET_CUSTOMER_RESPONSE:
      return { ...state, customers: action.payload };
    case types.GET_ORDERS_RESPONSE:
      return { ...state, order: action.payload };
    case types.CREATE_ORDERS:
      return { ...state, order: null };
    case types.UPDATE_ORDERS:
      return { ...state, order: null };
    case types.GET_PENDING_ORDERS:
      return { ...state, orders: [] };
    case types.GET_SHIPPED_ORDERS:
      return { ...state, orders: [] };
    case types.DELETE_ORDERS:
      return { ...state, order: null };
    case types.GET_TOTAL_SALES_RESPONSE:
      return { ...state, totalSale: action?.payload };
    case types.GET_TOTAL_ORDERS_RESPONSE:
      return { ...state, totalOrder: action?.payload };
    case types.GET_PENDING_COUNT_RESPONSE:
      return { ...state, pendingCount: action?.payload };
    case types.GET_SHIPPED_COUNT_RESPONSE:
      return { ...state, shippedCount: action?.payload };
    case types.GET_PACKED_COUNT_RESPONSE:
      return { ...state, packedCount: action?.payload };
    case types.GET_DELIVERED_COUNT_RESPONSE:
      return { ...state, deliveredCount: action?.payload };
    case types.GET_CANCELLED_COUNT_RESPONSE:
      return { ...state, cancelledCount: action?.payload };
    case types.GET_CART_BUNDLE_ID_ORDERS_RESPONSE:
      return { ...state, cartBundleId: action?.payload };
    case types.GET_CUSTOMERS_TOTAL_ORDERS_QUANTITY_RESPONSE:
      return { ...state, customerTotalOrders: action?.payload };
    case types.GET_ALL_ORDERS_BY_CARTBUNDLEID_RESPONSE:
      return { ...state, cartBundleIdOrder: action?.payload };
     case types.GET_ALL_COMPLETED_ORDERS_BY_CARTBUNDLES_RESPONSE:
      return { ...state, completedcartorder: action?.payload };


      
    

    default:
      return state;
  }
};

export default orders;
